module.exports = __webpack_public_path__ + "static/scale-model-of-cleveland-bike-tours-in-cleveland-ohio-fb0e97bca1a8d3e7f3c3def9f498d463.png";